import { Alert } from "react-bootstrap";
import type { WasteMovementDwtReadinessState } from "../react/useWasteMovementDwtReadiness";

/**
 * S2A readiness, shown inside the S2B submission panel: whether the saved Waste Received movement is ready for DEFRA
 * Digital Waste Tracking, and what to correct if not. Advisory: the server assesses readiness again on every submission.
 * Warnings never block. It offers no action itself - the submission panel owns the submit button.
 */
export function DwtReadinessSummary({ state }: { state: WasteMovementDwtReadinessState }) {
    return (
        <div data-testid="dwt-readiness-summary">
            {state.status === "loading" && <div className="text-muted small">Checking whether this movement is ready to submit…</div>}
            {state.status === "error" && (
                <div className="text-muted small" data-testid="dwt-readiness-error">
                    Readiness for DEFRA submission could not be checked. Reload the page to try again.
                </div>
            )}
            {state.status === "loaded" && (
                <>
                    {state.readiness.isReady ? (
                        <Alert variant="success" className="py-2 mb-2" data-testid="dwt-readiness-ready">
                            Ready to submit.
                        </Alert>
                    ) : (
                        <Alert variant="warning" className="py-2 mb-2" data-testid="dwt-readiness-blocked">
                            <div className="mb-1">Not ready for DEFRA submission. Correct the following:</div>
                            <ul className="mb-0">
                                {state.readiness.blockers.map((issue, index) => (
                                    <li key={`${issue.code}-${index}`} data-code={issue.code}>
                                        {issue.message}
                                    </li>
                                ))}
                            </ul>
                        </Alert>
                    )}
                    {state.readiness.warnings.length > 0 && (
                        <div className="small mb-2" data-testid="dwt-readiness-warnings">
                            <div className="fw-semibold">Warnings (these do not stop submission)</div>
                            <ul className="mb-0">
                                {state.readiness.warnings.map((issue, index) => (
                                    <li key={`${issue.code}-${index}`} data-code={issue.code}>
                                        {issue.message}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                    <div className="form-text mb-2">Checked against the saved movement; save your changes to check them.</div>
                </>
            )}
        </div>
    );
}
